import { Injectable } from "@angular/core";
import { LoginModel } from "../models/login.model";
import { TranslateService } from '@ngx-translate/core';
import { AuthorizeService } from "./authorize.service";
import { TokenService } from "./token.service";
import { postAuthorizeServiceResModel, postTokenServiceResModel } from "../models/serviceResponse.model";
import { BehaviorSubjectService } from "src/app/utility-packages/is-logged-in/behaviorSubject.service";


@Injectable()
export class LoginService{
  constructor(
    private translate: TranslateService, 
    private authorizeService: AuthorizeService, 
    private tokenService: TokenService, 
    private behaviorSubjectService: BehaviorSubjectService
  ){}


  login(obLogin: LoginModel){
    return new Promise((resolve, reject) =>{
      this.authorizeService.postAuthorize(obLogin).subscribe(
        (response: postAuthorizeServiceResModel ) => {
          if(response.error === true){
            return reject(response.message);
          }
          else{
            this.tokenService.postToken(response.code).subscribe(
              (response: postTokenServiceResModel) => {
                if(response.error){
                  return reject(response.message);
                }
                else{
                  //this.behaviorSubjectService.changeUserLoginStatus(true);
                  return resolve(response.accessToken);
                }
              },
              error => {
                return reject(error);      
              }
            )
          }
        },
        error => {
          return reject(error);
        }
      )
    })
  }
}